
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.31 14.69"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M14.38 3.86a1.93 1.93 0 1 1 1.93-1.93 1.94 1.94 0 0 1-1.93 1.93zm0-2.77a.84.84 0 1 0 .84.84.85.85 0 0 0-.84-.84zM5.68 7.43A1.93 1.93 0 1 1 7.61 5.5a1.94 1.94 0 0 1-1.93 1.93zm0-2.77a.85.85 0 0 0-.84.84.84.84 0 0 0 1.68 0 .85.85 0 0 0-.84-.84zM1.93 14.69a1.93 1.93 0 1 1 1.93-1.92 1.93 1.93 0 0 1-1.93 1.92zm0-2.76a.84.84 0 1 0 .84.84.84.84 0 0 0-.84-.84zM8.89 12.36a1.95 1.95 0 1 1 1.95-1.95 2 2 0 0 1-1.95 1.95zm0-2.81a.86.86 0 1 0 .86.86.85.85 0 0 0-.86-.86z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M13 3.28L9.54 8.57a2 2 0 0 1 .89.64L14 3.81a1.9 1.9 0 0 1-1-.53zM8.4 8.52L7 6.88a1.92 1.92 0 0 1-1 .51L7.45 9.1a2 2 0 0 1 .95-.58zM4.26 6.8l-2 4.07a1.9 1.9 0 0 1 1 .49l2-4a1.89 1.89 0 0 1-1-.56z"}})])])])
          )
        }
      }
    